import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-learning-resources-create',
  templateUrl: './learning-resources-create.component.html',
  styleUrls: ['./learning-resources-create.component.scss']
})
export class LearningResourcesCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

    ngOnInit() {
    this.Form = this.formBuilder.group({
      format: ['', Validators.required],
      heading: ['', Validators.required],
      duration: ['', [Validators.required]],
      institution: ['', [Validators.required]],
      course: ['', [Validators.required]],
      syllabus: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      subjectcode: ['', [Validators.required]],
      year: ['', [Validators.required]],
      sem: ['', [Validators.required]],
      taughtby: ['', [Validators.required]],
      description: ['', [Validators.required]],
      image: ['', [Validators.required]],
      _id: [''],
      seohidden: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/learningresourcesbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              format: data.data.format,
              heading: data.data.heading,
              duration: data.data.duration,
              institution: data.data.institution,
              course: data.data.course,
              syllabus: data.data.syllabus,
              subject: data.data.subject,
              subjectcode: data.data.subjectcode,
              year: data.data.year,
              sem: data.data.sem,
              taughtby: data.data.taughtby,
              description: data.data.description,
              image: data.data.image,
              _id: data.data._id,
              seohidden: data.data.seohidden
            })
            
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              format: '',
              heading: '',
              duration: '',
              institution: '',
              course: '',
              syllabus: '',
              subject: '',
              subjectcode: '',
              year: '',
              sem: '',
              taughtby: '',
              description: '',
              image: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
  });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "format"      : this.Form.value.format,
        "heading"      : this.Form.value.heading,
        "duration"  : this.Form.value.duration,
        "institution"  : this.Form.value.institution,
        "course"  : this.Form.value.course,
        "syllabus"  : this.Form.value.syllabus,
        "subject"  : this.Form.value.subject,
        "subjectcode"  : this.Form.value.subjectcode,
        "year"  : this.Form.value.year,
        "sem"  : this.Form.value.sem,
        "taughtby"  : this.Form.value.taughtby,
        "description"  : this.Form.value.description,
        "image"  : this.Form.value.image,
        "heading_url"  : this.Form.value.heading.toLowerCase().replace(/ /g, '-'),
        "admin" : sessionStorage.getItem('adminName'),
        "_id"           : this.Form.value._id,
        "seohidden": this.Form.value.seohidden
      };
      this.http.put<any>(this.api_endpoint+'/learningresources', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/learning-resources/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "format"      : this.Form.value.format,
        "heading"      : this.Form.value.heading,
        "duration"  : this.Form.value.duration,
        "institution"  : this.Form.value.institution,
        "course"  : this.Form.value.course,
        "syllabus"  : this.Form.value.syllabus,
        "subject"  : this.Form.value.subject,
        "subjectcode"  : this.Form.value.subjectcode,
        "year"  : this.Form.value.year,
        "sem"  : this.Form.value.sem,
        "taughtby"  : this.Form.value.taughtby,
        "description"  : this.Form.value.description,
        "heading_url"  : this.Form.value.heading.toLowerCase().replace(/ /g, '-'),
        "image"  : this.Form.value.image,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden": this.Form.value.seohidden
      };
      this.http.post<any>(this.api_endpoint+'/learningresources', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/learning-resources/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
